import Button from 'src/components/CardEdProgram/common/CardEdProgramSubscribe/CardEdProgramSubscribeButton';
import Dialog from 'src/components/CardEdProgram/common/CardEdProgramSubscribe/CardEdProgramSubscribeDialog';

export default { Button, Dialog };
